module.exports = __webpack_public_path__ + "img/393.26cc6dc8.jpg";